import React from "react";
import { BrowserRouter as Routers, Navigate, Route, useLocation, Routes, } from "react-router-dom";
import ProceedView from "../../screen/proceedView/ProceedView";
import ThankYou from "../../screen/thankYou/ThankYou";
import OtpVerification from "../../screen/otp/otpVerification";
import TemplateView from "../../screen/templateView/TemplateView";
import IdvCompletion from "../../screen/idvCompletion";
import AccountScoreBankReport from "../../screen/accountScoreBankReport";
import AccountScoreCreditReport from "../../screen/accountScoreCreditReport";
import IdvReport from "../../screen/idvReport";

export default function Rout() {
    return (
        <>
            <Routers>
                <Routes>
                    <Route path="/proceedView" element={<ProceedView />} />
                    <Route path="/thankYou" element={<ThankYou />} />
                    <Route path="/templateView" element={<TemplateView />} />
                    <Route path="/idvCompletion" element={<IdvCompletion />} />
                    <Route path="/accountScoreBankReport" element={<AccountScoreBankReport />} />
                    <Route path="/accountScoreCreditReport" element={<AccountScoreCreditReport />} />
                    <Route path="/idvReport" element={<IdvReport />} />
                    <Route path="/" element={<TemplateView />} />
                    <Route path="/:token" element={<TemplateView />} />
                </Routes>
            </Routers>
        </>
    );
}
